<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div id="customer-form">
        <div class="row">
          <div class="col-sm-6">
            <div class="card">
              <Registration />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Registration from '@/components/views/registration';

  export default {
    name: "CustomerCreate",
    components: {Registration}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/CustomerCreate.vue